const SEARCH_QUERY_PARAM = 'q';

const FILTER_QUERY_PARAMS = {
  source: 'source',
  author: 'author',
  dateRange: 'date_range',
  customStartDate: 'start_date',
  customEndDate: 'end_date',
};

export const parseSearchState = (search = '') => {
  const params = new URLSearchParams(search);
  const customStartDate = params.get(FILTER_QUERY_PARAMS.customStartDate) || '';
  const customEndDate = params.get(FILTER_QUERY_PARAMS.customEndDate) || '';
  const dateRange = (
    params.get(FILTER_QUERY_PARAMS.dateRange)
    || ((customStartDate || customEndDate) ? 'custom' : '')
  );

  return {
    query: params.get(SEARCH_QUERY_PARAM) || '',
    filters: {
      source: params.get(FILTER_QUERY_PARAMS.source) || '',
      author: params.get(FILTER_QUERY_PARAMS.author) || '',
      dateRange,
      customStartDate,
      customEndDate,
    },
  };
};

export const readSearchStateFromUrl = () => {
  if (typeof window === 'undefined') {
    return parseSearchState('');
  }

  return parseSearchState(window.location.search);
};

export const buildSearchStateUrl = (location, nextQuery, nextFilters = {}) => {
  const params = new URLSearchParams(location.search || '');
  const trimmedQuery = (nextQuery || '').trim();

  if (trimmedQuery) {
    params.set(SEARCH_QUERY_PARAM, trimmedQuery);
  } else {
    params.delete(SEARCH_QUERY_PARAM);
  }

  Object.entries(FILTER_QUERY_PARAMS).forEach(([filterKey, paramName]) => {
    const rawValue = nextFilters[filterKey];
    const value = typeof rawValue === 'string' ? rawValue.trim() : rawValue;

    if (filterKey === 'dateRange' && value === 'custom') {
      params.delete(paramName);
    } else if (value) {
      params.set(paramName, value);
    } else {
      params.delete(paramName);
    }
  });

  const queryString = params.toString();
  const pathname = location.pathname || '';
  const hash = location.hash || '';

  return `${pathname}${queryString ? `?${queryString}` : ''}${hash}`;
};

export const syncSearchStateToUrl = (nextQuery, nextFilters) => {
  if (typeof window === 'undefined') {
    return;
  }

  const nextUrl = buildSearchStateUrl(window.location, nextQuery, nextFilters);
  const currentUrl = `${window.location.pathname}${window.location.search}${window.location.hash}`;

  if (nextUrl !== currentUrl) {
    window.history.replaceState({}, '', nextUrl);
  }
};
